import { jsx as _jsx } from "react/jsx-runtime";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ReleaseValidations } from "../components/route/real-cookie-banner/release/release-validations.js";
/**
 * Validate the given template for successorOf configuration for release!
 *
 * @param template could be a service or a blocker for example
 * @param deletedTemplates be sure to provide deleted templates of the same kind for given template
 * @param t translation helper
 * @returns
 */ function validateTemplateSuccessorOfIdentifier(template, deletedTemplates, t) {
    const successorIdentifiers = template?.successorOfIdentifier || [];
    const validations = successorIdentifiers.map((identifier)=>{
        const found = deletedTemplates.find((deleted)=>deleted.identifier === identifier);
        let validation;
        if (found && !found.isDeleted) {
            // Invalid! Only deleted are allowed
            validation = {
                id: String(template.id),
                identifier: template.identifier,
                type: "error",
                message: t("Only deleted templates are valid as successors. {{headline}} must be deleted or removed from the current template configuration.", {
                    headline: found.headline
                }),
                showIcon: true
            };
        }
        return validation;
    }).filter(Boolean);
    return validations;
}
function getReleaseValidationExpandable(validations, showExpandColumn, defaultExpandedRowKeys) {
    return {
        rowExpandable: (record)=>!!validations?.find((v)=>v.identifier === record.identifier),
        expandedRowRender: (record)=>{
            const found = validations?.filter((v)=>v.identifier === record.identifier);
            return /*#__PURE__*/ _jsx(ReleaseValidations, {
                releaseValidationResults: found
            });
        },
        showExpandColumn: showExpandColumn,
        defaultExpandedRowKeys,
        columnTitle: /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {
            style: {
                color: "red",
                textAlign: "center"
            }
        })
    };
}
export { getReleaseValidationExpandable, validateTemplateSuccessorOfIdentifier };
